import {Profession, ProfessionMapping} from "../../resources/application"
import React from "react"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableProfessionProps {
	profession?: Profession
	setProfession: (value: Profession) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: (value: Profession) => void
	className?: string
}

export function EditableProfessionField(props: EditableProfessionProps) {
	if (props.profession) {
		return (
			<Editable
				label="Profession"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setProfession}
				value={props.profession}
				initial={props.profession}
				update={props.update}
				className={props.className}
				possibleValues={ProfessionMapping}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
